export enum BILoginType {

    Regular = "Regular",
    Remembered = "Remembered"
}
